<template>
  <v-container fluid grid-list-md>
    <!-- dialog para inserção de senha -->
    <p-file-password-dialog ref="pDelete" :clearPassword="clearPassword" :loading="fileLoading" :dialog="passDialog" @passChangeConfirm="(pass) => {passChangeConfirm(pass)}" @passChangeCancel="passChangeCancel"></p-file-password-dialog>
    <v-layout wrap justify-center align-center>
      <v-flex xs12>
         <vue-dropzone id="dropzone" :options="dropOptions" ref="dropzone" v-on:vdropzone-sending="sendingEvent" 
                      v-on:vdropzone-success="successEvent" v-if="!task_shared && checkPermission(this.entity, 'create')"
                      v-on:vdropzone-error="errorEvent" v-on:vdropzone-file-added="fileAdded"></vue-dropzone>
         <v-card color="cyan" v-else>
            <div class="vue-dropzone dropzone"><div class="dz-default dz-message"><span>&nbsp;Você não tem permissão para incluir arquivos!</span></div></div>
          </v-card>
      </v-flex>
      <v-flex xs12 sm8>
        <span class="headline">Arquivos</span>
      </v-flex>
      <v-flex xs12 sm4>
        <v-text-field append-icon="search" label="Pesquisar" v-model="search"></v-text-field>
      </v-flex>
      <!--Dialog para confirmação de exclusão-->
      <p-confirm text="Tem certeza que deseja excluir o item de " :entity="translate('table.' + entity + '.title')[1]" :dialog="dialogConfirm" @confirm="(tempDeletedItem.user_id === $auth.user().id || tempDeletedItem.password === null) ? processDelete(tempDeletedItem) : initPassDialog(tempDeletedItem, 2, 2)" @cancel="closeDialogDelete"></p-confirm>
      <!--Index-->
      <v-flex xs12>
        <v-card>
          <v-layout>
            <v-flex xs10>
              <v-subheader>Descrição</v-subheader>
            </v-flex>
            <v-flex xs2>
              <v-subheader>Ações</v-subheader>
            </v-flex>
          </v-layout>
          <v-divider></v-divider>
          <v-list two-line subheader>
            <template v-for="(item, index) in filteredFiles">
                <v-hover :key="index + 2000">
                  <v-list-tile :key="index" avatar @click="" slot-scope="{ hover }">
                    <v-menu absolute offset-y>
                      <template v-slot:activator="{ on }">
                        <v-list-tile-avatar v-on="on" >
                          <v-progress-circular
                            slot="activator"
                            v-if="item.loading_download"
                            :value="item.loading_value_download"
                            color="deep-purple"
                          >{{ item.loading_value_download }}</v-progress-circular>
                          <v-progress-circular
                            slot="activator"
                            v-else-if="item.loading_view"
                            :value="item.loading_value_view"
                            color="teal"
                          >{{ item.loading_value_view }}</v-progress-circular>
                          <v-btn v-else fab small color="#00acc2">
                            <v-icon color="#fff" v-if="hover">cloud_download</v-icon>
                            <v-icon color="#fff" v-else>{{avatarSrc(item.extension)}}</v-icon>
                          </v-btn>
                        </v-list-tile-avatar>

                        <v-list-tile-content v-on="on">
                          <v-list-tile-title><a>{{`${item.id_text}.${item.extension}`}}</a><span style="color: gray; font-size:11px;"> - {{item.created_at | formatDateTime}}</span> </v-list-tile-title>
                          <v-list-tile-title>{{(item.size / 1000000).toFixed(2)}} MB</v-list-tile-title>
                          <v-list-tile-sub-title>{{ item.user ? item.user.id_text.split(' ').slice(0, 2).join(' ') : '' }}</v-list-tile-sub-title>
                        </v-list-tile-content>
                      </template>

                      <v-list>
                        <v-tooltip bottom>
                          <v-list-tile @click="item.user_id === ($auth.check() ? $auth.user().id : 0) || item.password === null ? downloadItem(item, '', true) : initPassDialog(item, 4)" avatar :disabled="!'pdf.png.jpeg.jpg.ico.txt.sql'.includes(item.extension)" slot="activator">
                            <v-list-tile-avatar>
                              <v-icon color="teal">visibility</v-icon>
                            </v-list-tile-avatar>
                            <v-list-tile-title>Visualizar</v-list-tile-title>
                          </v-list-tile>
                          <span v-if="'pdf.png.jpeg.jpg.ico.txt.sql'.includes(item.extension)">Visualizar</span>
                          <span v-else>Não é possível visualizar esse arquivo</span>
                        </v-tooltip>
                        
                        <v-list-tile @click="item.user_id === ($auth.check() ? $auth.user().id : 0) || item.password === null ? downloadItem(item) : initPassDialog(item, 4)" avatar>
                          <v-list-tile-avatar>
                            <v-icon color="deep-purple">cloud_download</v-icon>
                          </v-list-tile-avatar>
                          <v-list-tile-title>Baixar</v-list-tile-title>
                        </v-list-tile>
                      </v-list>
                    </v-menu>
                    <!-- <v-list-tile-content>
                    <v-list-tile-title style="color: black;font-family: Arial"><strong>{{translate('value.reminder_type').filter(a=>a.value === item.type)[0].text}}</strong>{{translate('module.task.reminder.message')}}<strong>{{item.user['id_text']}}</strong> dia <strong>{{ item.date | formatDateTime }}</strong></v-list-tile-title>
                    </v-list-tile-content> -->
                    <v-list-tile-action>
                      <v-menu left nudge-top="8" content-class="elevation-0 menu_content" transition="slide-x-reverse-transition" :offset-x="true">
                        <template v-slot:activator="{ on, attrs }" v-on="on">
                          <v-btn fab small slot="activator" v-on="on" icon class="mx-0">
                            <v-icon medium>more_vert</v-icon>
                          </v-btn>
                        </template>
                        <v-tooltip bottom>
                          <v-btn slot="activator" small fab class="mx-0">
                            <v-icon color="grey darken-1">list</v-icon>
                          </v-btn>
                          <span>
                            <p-other-field :othersFields="othersFields(item)"></p-other-field>
                          </span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <!-- $auth.check() usado para tarefa compartilhada -->
                          <v-btn :disabled="(($auth.check() ? $auth.user().id : 0) !== item.user_id) || !checkPlanAccess('files_password', 'has')" slot="activator" small fab class="mx-0" @click="initPassDialog(item, 3, 1, (item.password !== null))">
                            <v-icon color="black">{{item.password !== null ? 'lock' : 'lock_open'}}</v-icon>
                          </v-btn>
                          <span>{{!checkPlanAccess('files_password', 'has') ? 'Seu plano não tem acesso aos arquivos com senha' : ($auth.check() ? $auth.user().id : 0) === item.user_id ? (item.password === null ? 'Incluir Senha' : 'Alterar Senha') : (item.password === null ? 'Somente quem adicionou o arquivo pode incluir a senha' : 'Somente quem adicionou o arquivo pode alterar a senha')}}</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <v-btn slot="activator" small fab class="mx-0" @click="processEditItem(item)" :disabled="task_shared || (!task.crud_access && item.user_id !== $auth.user().id) || (!checkPermission('files', 'edit'))">
                            <v-icon color="teal">edit</v-icon>
                          </v-btn>
                          <span>{{editTooltipText}}</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <v-btn slot="activator" small fab class="mx-0" @click="beforeDialogDelete(item)" :disabled="task_shared || (!task.crud_access && item.user_id !== $auth.user().id) || (!checkPermission('files', 'delete'))">
                            <v-icon color="pink">delete</v-icon>
                          </v-btn>
                          <span>{{deleteTooltipText}}</span>
                        </v-tooltip>
                      </v-menu>
                    </v-list-tile-action>
                  </v-list-tile>
                </v-hover>
              
              <!-- // soma com mil pois já é usado o index no list -->
              <v-divider :key="index + 1000" v-if="index + 1 < items.length"></v-divider>
            </template>
            <v-list-tile three-line v-if="items.length === 0">
              {{emptyTable}}
            </v-list-tile>
          </v-list>
        </v-card>
      </v-flex>
    </v-layout>
    <!--foi colocado o v-if="dialog" porque o pselecteditable carregava antes da requisição ser feita, então o campo vinha vazio mesmo tendo registros-->
    <!--Create Edit-->
    <v-dialog v-model="dialog" max-width="1200px" persistent scrollable>
      <v-card>
        <v-card-title primary-title>
          <span class="headline">{{formTitle}}</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form v-model="valid" v-if="dialog" ref="form">
            <v-container grid-list-md>
              <v-layout wrap justify-center align-center>
                <v-flex xs12>
                  <v-text-field maxlength="190" counter="190" :rules="requiredFileNameRule(translate('table.' + entity + '.field.id_text'))" ref="autofocus" @keyup.native.esc="close(400)" :label="translate('table.' + entity + '.field.id_text')"
                                v-model="editedItem.id_text" @keyup.native.ctrl.enter="save()"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <p-select-modal-editable id="taskfile_category_id"
                  :showActions="editedItem.company_id === $auth.user().company_id" :clearable="false" :label="translate('table.' + entity + '.field.category_id')" @change="(id, item) => {editedItem['category'] = item}" v-model="editedItem.category_id" entity="select_editable" :values="category_fields" :selectedItem="editedItem.category" :companyId="editedItem['company_id']">
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex>
                        <v-text-field id="modalfocus" v-model="category_fields.id_text" :label="translate('table.task_status.field.id_text')"></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </p-select-modal-editable>
                </v-flex>
                <v-flex xs12 sm6>
                  <p-select-modal-editable id="taskfile_subcategory_id"
                  :showActions="editedItem.company_id === $auth.user().company_id" :clearable="false" :label="translate('table.' + entity + '.field.subcategory_id')" @change="(id, item) => {editedItem['subcategory'] = item}" v-model="editedItem.subcategory_id" entity="select_editable" :values="subcategory_fields"  :selectedItem="editedItem.subcategory" :companyId="editedItem['company_id']">
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex>
                        <v-text-field id="modalfocus" v-model="subcategory_fields.id_text" :label="translate('table.task_status.field.id_text')"></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </p-select-modal-editable>
                </v-flex>
                <v-flex xs12 sm6>
                  <p-date :label="translate('table.' + entity + '.field.emission')"
                          v-model="editedItem.emission" :rules="dateDiffRule(false, 'data', editedItem.emission, editedItem.maturity)" @keyup.native.ctrl.enter="save()"></p-date>
                </v-flex>
                <v-flex xs12 sm6>
                  <p-date :label="translate('table.' + entity + '.field.maturity')"
                          :rules="dateDiffRule(false, 'data', editedItem.emission, editedItem.maturity)" v-model="editedItem.maturity" @keyup.native.ctrl.enter="save()"></p-date>
                </v-flex>
                <v-flex xs12>
                  <v-textarea @keyup.native.esc="close(400)" :label="translate('table.' + entity + '.field.note')" @keyup.native.ctrl.enter="save()"
                              v-model="editedItem.note"></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="mx-0" color="primary darken-2" :loading="loading" @click.native="save()">Salvar</v-btn>
          <v-btn class="mx-0" @click.native="close(400)">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<style>
  .dz-preview {
    z-index: 0;
  }
  .speed-dial {
    display: inline !important;
  }
  .menu_content {
    padding: 0 10px 10px 10px;
  }
</style>

<script>
  import vueDropzone from 'vue2-dropzone'
  import crud from './../../mixin/crud'
  import access from './../../mixin/access'
  import tooltip from './../../mixin/tooltip'
  import PDate from './../shared/PDate'
  import moment from 'moment'
  import rules from './../../mixin/rules'
  import PSelectModalEditable from './../shared/PSelectModalEditable'
  import PFilePasswordDialog from './../shared/PFilePasswordDialog.vue'
  import POtherField from './../shared/POtherField'
  import PConfirm from './../shared/PConfirm'

  export default {
    mixins: [crud, rules, tooltip, access],
    components: {
      vueDropzone, PFilePasswordDialog, PDate, PSelectModalEditable, POtherField, PConfirm
    },
    data: () => ({
      entity: 'files',
      category_fields: {},
      subcategory_fields: {},
      fileLoading: false,
      tempItem: {},
      actAfterPassword: 1,
      tempDeletedItem: {},
      deletepass: '',
      clearPassword: false,
      pagination: {
        sortBy: 'created_at'
      },
      passDialog: false,
      beforePassword: null,
      password: '',
      dropOptions: {
        headers: {'Authorization': 'Bearer ' + localStorage.getItem('auth_token_default')},
        maxFilesize: 2048,
        timeout: 3600000,
        url: `${process.env.API}api/files`,
        thumbnailWidth: 100,
        thumbnailHeight: 100,
        maxThumbnailFilesize: 100,
        dictDefaultMessage: '<i class="fa fa-cloud"></i>\t&nbspSolte os arquivos aqui ou clique para salvá-los',
        dictFileTooBig: 'O upload não pôde ser efetuado, por favor insira arquivos de até 2GB',
        addRemoveLinks: true,
        dictCancelUpload: 'Cancelar',
        dictUploadCanceled: 'Upload cancelado!',
        dictCancelUploadConfirmation: 'Tem certeza que deseja cancelar este upload?',
        dictRemoveFile: 'Remover',
        dictRemoveFileConfirmation: null
      },
      items: []
    }),
    name: 'File',
    props: {
      task: Object,
      task_shared: {
        type: Boolean,
        default: false
      }
    },
    sockets: {
      // socket utilizado para alterar os dados do taskFile, quando utilizado pelo mixin do socket todos os dados alterados são referentes ao Task.vue
      editSocketManagementDetails (item) {
        this.$store.commit('snackbar/change_values', {
          text: `Houve alterações nesta ${item.entity}, poderá haver conflitos. Verifique as mudanças.`, color: 'warning', dialog: true, timeout: 20000
        })
        Object.assign(this.editedItem, JSON.parse(JSON.stringify(item.values)))
        Object.assign(this.editedItemDB, JSON.parse(JSON.stringify(item.values)))
      },
      socketCloseDialog (item) {
        this.$store.commit('snackbar/change_values', {
          text: `O arquivo em gerenciamento foi deletado.`, color: 'warning', dialog: true, timeout: 20000
        })
        this.close(400)
      }
    },
    created () {
      this.items = this.task.files
      // se a tarefa for compartilhada não precisa recarregar os valores
      if (!this.task_shared) {
        this.editedItem = {task_id: this.task.id, emission: '', maturity: '', id: '', id_text: '', path: '', extension: '', size: '', note: '', category_id: '', subcategory_id: '', user_id: '', connection_company_id: '', created_at: '', updated_at: '', company_id: '', category: '', subcategory: ''}
        this.defaultItem = {task_id: this.task.id, emission: '', maturity: '', id: '', id_text: '', path: '', extension: '', size: '', note: '', category_id: '', subcategory_id: '', user_id: '', connection_company_id: '', created_at: '', updated_at: '', company_id: '', category: '', subcategory: ''}
        // Caso a empresa da tarefa seja diferente da empresa que o usuário está logado, significa que o usuário é de um parceiro
        if (this.task.company_id !== this.$auth.user().company_id) {
          this.editedItem.connection_company_id = this.$auth.user().company_id
          this.defaultItem.connection_company_id = this.$auth.user().company_id
        }
        this.category_fields = {id_text: '', active: true, type: 'file_category', company_id: this.task.company_id}
        this.subcategory_fields = {id_text: '', active: true, type: 'file_subcategory', company_id: this.task.company_id}
      }
      this.pagination.descending = !this.pagination.descending
    },
    mounted: function () {
      this.$emit('itemsLength', this.items.length)
    },
    methods: {
      processDelete (item) {
        this.editedItem = item
        this.deleteItem()
      },
      afterUpdate (res) {
        this.$socket.emit('generalDetailsEvent', {
          data: res,
          details: 'files',
          responseEvent: 'editSocketDetails',
          room: `tasks${this.task.id}_manage`
        })
        // Enviando o evento para tela de arquivos
        this.$socket.emit('generalEvent', {
          data: res,
          responseEvent: 'editSocketItem',
          room: `files${this.task.company_id}`
        })
        this.$socket.emit('generalEvent', {
          data: {values: res, entity: 'arquivo'},
          responseEvent: 'editSocketManagementDetails',
          room: `files${res.id}_manage`
        })
      },
      beforeDialogDelete (item) {
        this.tempDeletedItem = item
        this.dialogDelete(item)
      },
      processEditItem (item) {
        this.tempItem = item
        if (item.password === null) {
          delete this.editedItem.password
          this.editItem(item)
        } else {
          this.$http.get(`api/getFilePassword?id=${item.id}`).then(res => {
            delete this.editedItem.password
            this.editItem(item)
          }, err => {
            console.log(err)
            this.initPassDialog(item, 2, 3)
          })
        }
      },
      afterDelete (res) {
        this.$emit('itemsLength', this.items.length)
        this.$socket.emit('generalDetailsEvent', {
          data: res,
          details: 'files',
          responseEvent: 'deleteSocketDetails',
          room: `tasks${this.task.id}_manage`
        })
        // Emitindo evento para deletar arquivo no campo personalizado
        this.$socket.emit('generalEvent', {
          data: res,
          notBroadcast: true,
          responseEvent: 'deleteFileCustomField',
          room: `tasks${res['task_id']}_manage`
        })
        // Enviando evento para a tela de arquivo
        this.$socket.emit('generalEvent', {
          data: res,
          responseEvent: 'deleteSocketItem',
          room: `files${this.task.company_id}`
        })
        this.$socket.emit('generalEvent', {
          data: {text: 'Este Arquivo foi deletado, por favor recarregue a página para não haver conflitos.'},
          responseEvent: 'reloadPageModules',
          room: `files${res.id}_manage`
        })
        this.$socket.emit('generalEvent', {
          data: {entity: this.entity},
          responseEvent: 'socketCloseDialog',
          room: `files${res.id}_manage`
        })
      },
      initPassDialog (item, view = 3, after = 1, clear = false) {
        if (clear) this.clearPassword = true
        this.passDialog = true
        this.dialogConfirm = false
        this.view = view
        this.actAfterPassword = after
        this.editedItem = {id: item.id, task_id: item.task_id, id_text: item.id_text, extension: item.extension}
        if (view === 3) {
          if (item.password === null) this.password = ''
          else {
            this.fileLoading = true
            this.$http.get(`api/getFilePassword?id=${item.id}`).then(res => {
              this.editedItem['password'] = res.body
              this.password = this.editedItem['password'] === null ? '' : atob(this.editedItem['password'])
              this.$refs.pDelete.password = this.password
            })
            this.fileLoading = false
          }
        }
      },
      passChangeConfirm (pass) {
        if (this.view === 3) {
          if (pass !== '') {
            this.editedItem.password = btoa(pass)
          } else {
            this.editedItem.password = null
          }
          // this.editedItem.password = this.password === '' ? null : btoa(JSON.parse(JSON.stringify(this.password)))
          this.save()
        } else {
          this.deletepass = btoa(pass)
          if (this.actAfterPassword === 1) this.downloadItem(this.editedItem, pass)
          if (this.actAfterPassword === 2) this.deleteItem(`?password=${this.deletepass}`)
          if (this.actAfterPassword === 3) {
            this.$http.get(`api/checkFilePassword?id=${this.editedItem.id}&password=${btoa(pass)}`).then(res => {
              delete this.editedItem.password
              this.editItem(this.tempItem)
            }, err => {
              console.log(err)
              this.$store.commit('snackbar/change_values', {
                text: 'Senha invalida!',
                color: 'warning',
                dialog: true
              })
            })
          }
        }
        this.password = ''
        this.passDialog = false
        this.clearPassword = false
      },
      passChangeCancel () {
        this.password = ''
        this.passDialog = false
        this.clearPassword = false
      },
      // função de caso o arquivo é inserido na fila de upload, aqui é removido o botão sem que se perca a sua referencia, é apenas esvaziada a tag html <a></a>
      fileAdded (file) {
        const removeButton = file.previewElement.querySelector('.vue-dropzone.dropzone.dz-clickable.dz-started a')
        removeButton.className = ''
        removeButton.innerHTML = ''
        removeButton.href = ''
      },
      sendingEvent (file, xhr, formData) {
        var _this = this
        // referencia do botao para proximas alterações
        const removeButton = file.previewElement.querySelector('.vue-dropzone.dropzone.dz-clickable.dz-started a')
        // função implementada em casos de timeouts, onde o tempo de upload de arquivo é excedido
        xhr.ontimeout = function (e) {
          const element = file.previewElement.querySelector('.dz-error-message span')
          element.textContent = 'Tempo limite de upload expirado!'
          file.previewElement.className = 'dz-preview dz-file-preview dz-error dz-complete'
          _this.$store.commit('snackbar/change_values', {
            text: 'O arquivo ' + file.name + ' atingiu o tempo limite de upload!',
            color: 'error',
            dialog: true,
            timeout: 7000
          })
          removeButton.remove()
        }
        removeButton.className = 'dz-remove'
        formData.append('task_id', this.task.id)
        formData.append('user_id', this.$auth.user().id)
        formData.append('company_id', this.task.company_id)
        formData.append('connection_company_id', this.$auth.user().company_id)
      },
      beforeEditItem (item) {
        this.$socket.emit('joinRoom', {room: `files${item.id}_manage`})
      },
      afterClose (oldValues) {
        this.$socket.emit('leaveRoom', {room: `files${oldValues.id}_manage`})
      },
      successEvent (file, xhr, formData) {
        this.items.unshift(xhr)
        this.$emit('itemsLength', this.items.length)
        this.$store.commit('snackbar/change_values', {text: 'Registro de ' + this.translate('table.' + this.entity + '.title')[0] + ' incluído com sucesso!', color: 'success', dialog: true})
        this.$socket.emit('generalDetailsEvent', {
          data: xhr,
          details: 'files',
          responseEvent: 'addSocketDetails',
          room: `tasks${this.task.id}_manage`
        })
        // linha utilizada para informar a Tela de Arquivos que este elemento veio da tela de Tarefas
        xhr.source = 2
        // Emitindo evento para adicionar arquivo à tela de arquivos
        this.$socket.emit('generalEvent', {
          data: xhr,
          responseEvent: 'addSocketItem',
          room: `files${this.task.company_id}`
        })
        const removeButton = file.previewElement.querySelector('.vue-dropzone.dropzone.dz-clickable.dz-started a')
        removeButton.remove()
      },
      errorEvent (file, error, xhr) {
        if (typeof error === 'string') {
          // erro se o servidor cai
          if (error.indexOf('responded with 0 code') !== -1) {
            const elements = document.querySelectorAll('.dz-error-message span')
            elements.forEach((val) => {
              if (val.textContent.indexOf('responded with 0 code.') !== -1) val.textContent = 'O servidor não está respondendo, cheque sua conexão com a internet!'
            })
            this.$store.commit('snackbar/change_values', {
              text: 'O servidor não está respondendo, cheque sua conexão com a internet!',
              color: 'error',
              timeout: 7000,
              dialog: true
            })
            return
            // erro de limite de arquivo excedido
          } else if (error.indexOf('arquivos de até 2GB') !== -1) {
            this.$store.commit('snackbar/change_values', {
              text: `O upload não pôde ser efetuado, por favor insira arquivos de até 2GB!`,
              color: 'error',
              dialog: true
            })
            return
          }
          // erro de limite do plano de arquivos é excedido
        } else if (error.message.includes('limit|')) {
          // tratamento de erro caso o limite do plano seja atingido
          this.$store.commit('snackbarPlan/change_values', {
            text: `Não foi possível incluir o arquivo!`,
            dialog: true
          })
          // busca a memoria do plano do usuário
          let sizePlan = this.getterAccesses.find((res) => {
            return (res.id_text === 'files' && res.hasOwnProperty('size'))
          })
          // caso não tenha a variavel de tamanho, insere 0
          sizePlan = !sizePlan ? 0 : sizePlan['size']
          // transforma bit em MB
          let sumSizeFiles = (parseInt(sizePlan) - parseInt(error.message.split('|')[1])) / 1000000
          this.$store.commit('dialogPlan/change_values', {
            title: 'Memória excedida',
            text: `Esse arquivo ultrapassa o limite do seu plano, você tem apenas <strong>${Math.round(sumSizeFiles)} MB disponível</strong>. Aproveite e faça o upgrade agora mesmo!`,
            showDialog: true
          })
          // erro de permissão de envio de arquivo
        } else if (error.message.indexOf('stream: Permission denied') !== -1) {
          const elements = document.querySelectorAll('.dz-error-message span')
          elements.forEach((val) => {
            if (val.textContent === '[object Object]') val.textContent = 'Não foi possivel obter permissão do sistema para inserir este arquivo!'
          })
          this.$store.commit('snackbar/change_values', {
            text: `Não foi possivel obter permissão do sistema para inserir este arquivo!`,
            coloc: 'error',
            dialog: true
          })
        }
        this.$store.commit('snackbar/change_values', {text: 'Não foi possível incluir o registro de ' + this.translate('table.' + this.entity + '.title')[0] + '.', color: 'error', dialog: true})
        const removeButton = file.previewElement.querySelector('.vue-dropzone.dropzone.dz-clickable.dz-started a')
        removeButton.remove()
      },
      downloadItem (item, password = '', onlyView = false) {
        this.onlyView = onlyView
        // seta true para o loading começar a rodar
        this.$set(item, `loading_${onlyView ? 'view' : 'download'}`, true)
        this.$set(item, `loading_value_${onlyView ? 'view' : 'download'}`, 0)
        this.$http.get(`api/${this.entity}/download/${item.id}?${item.task_id !== null ? `task=${item.task_id}&` : ''}shared=${false}${password === '' ? '' : `&password=${btoa(password)}`}`, {
          responseType: 'arraybuffer',
          progress (e) {
            if (e.lengthComputable) {
              item[`loading_value_${onlyView ? 'view' : 'download'}`] = Math.floor(e.loaded / e.total * 100)
            }
          }
        }).then(res => {
          let blob = new Blob([res.data], {type: res.headers.get('content-type')})
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          if (onlyView) {
            window.open(link, '_blank')
          } else {
            link.download = item.id_text + '.' + item.extension
            link.click()
          }
          item[`loading_${onlyView ? 'view' : 'download'}`] = false
        }, err => {
          console.log(err)
          item[`loading_${onlyView ? 'view' : 'download'}`] = false
          if (err.status === 400) {
            this.$store.commit('snackbar/change_values', {
              text: 'Senha invalida!',
              color: 'warning',
              dialog: true
            })
          }
        })
      },
      othersFields (item) {
        return [
          {field: this.translate('table.' + this.entity + '.field.category_id'), value: item.category ? item.category.id_text : ''},
          {field: this.translate('table.' + this.entity + '.field.subcategory_id'), value: item.subcategory ? item.subcategory.id_text : ''},
          {field: this.translate('table.' + this.entity + '.field.emission '), value: item.emission ? moment(String(item.emission)).format('DD/MM/YYYY') : ''},
          {field: this.translate('table.' + this.entity + '.field.maturity '), value: item.maturity ? moment(String(item.maturity)).format('DD/MM/YYYY') : ''},
          {field: this.translate('table.' + this.entity + '.field.note '), value: item.note ? item.note : ''}
        ]
      },
      avatarSrc (extension) {
        switch (extension) {
          case 'pdf': return 'picture_as_pdf'
          case 'png': case 'jpg': case 'jpeg': case 'gif': return 'image'
          case 'docx': case 'rtf': return 'description'
          case 'mp4': return 'videocam'
          default: return 'insert_drive_file'
        }
      }
    },
    computed: {
      filteredFiles () {
        let fieldSearch = ['id_text']
        return this.items.filter(i => (
          fieldSearch.some(j => {
            return i[j] ? i[j].toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').match(this.search.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')) : false
          })
        ))
      },
      headers: function () {
        return [
          {text: this.translate('table.' + this.entity + '.field.id_text'), value: 'id_text', width: '30%'},
          {text: this.translate('table.' + this.entity + '.field.category_id'), value: 'category.id_text', width: '15%'},
          {text: this.translate('table.' + this.entity + '.field.emission'), value: 'emission', width: '10%'},
          {text: 'Postado por', value: 'user.id_text', width: '15%'},
          {text: this.translate('system.table.action'), value: 'action', sortable: false, align: 'center'}
        ]
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/details/TaskFile.vue